import React, { useState } from 'react';
import "../Components/UserSignIn/Register.css";
import axios from 'axios';

const Register = () => {
  const [formState, setFormState] = useState({
    username: '',
    email: '',
    password: '',
  });

  const [message, setMessage] = useState('');

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormState({
      ...formState,
      [name]: value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await axios.post('/api/v1/users/register', formState);
      setMessage('Account created successfully');
      console.log('Account created successfully:', response.data);
    } catch (error) {
      if (error.response){
        setMessage(`${error.response.status}: ${error.response.data.message}`);
      } else if (error.request) {
        setMessage("No response from server");
      } else {
        setMessage("Error setting up request");
      }
      console.error('Error creating account:', error);
    }
  };

  return (
    <div className="create-account">
      <h1>Create an Account</h1>
      
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Username:</label>
          <input
            id="usernameRegister"
            type="text"
            name="username"
            value={formState.username}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label>Email:</label>
          <input
            id="emailRegister"
            type="email"
            name="email"
            value={formState.email}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label>Password:</label>
          <input
            id="passwordRegister"
            type="password"
            name="password"
            value={formState.password}
            onChange={handleChange}
          />
        </div>
        {message && <div className="message">{message}</div>}  {/* Display message */}
        <button className="create-account-button" type="submit">Create Account</button>
        <div className="login-link">
          <a href="/signin" id="toLogin">Already have an account? Log in!</a>
        </div>
      </form>
    </div>
  );
};

export default Register;
